// App.js
import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Home from "./pages/HomePage";
import NavBar from "./common/Header";
import Footer from "./common/Footer";
import VehicleSelection from "./components/VehicleSelection";
import ContactDetails from "./components/ContactDetails";
import AuthScreen from "./Auth/AuthScreen";
import OffersPageV3 from "./pages/OffersPageV3";
import SafetyPage from "./pages/Safty";
import SupportPage from "./pages/Supportpage";
import ScrollToTop from "./pages/ScrollToTop";
import BookingSuccess from "./components/BookingSuccess";
import AdminPanel from "./Admin/AdminPanel";
import ChennaiTaxiMasterPage from "./pages/location/ChennaiTaxiMasterPage";
import SEO from "./components/SEO";
import StaticPageRoute from "./pages/static/StaticPageRoute";
import AppSplash from "./components/AppSplash";

function App() {
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    const splashTimer = window.setTimeout(() => {
      setShowSplash(false);
    }, 1900);

    return () => window.clearTimeout(splashTimer);
  }, []);

  return (
    <HelmetProvider>
      {showSplash && <AppSplash />}
      <Router>
        <ScrollToTop />
        
        {/* Global SEO */}
        <SEO 
          title="BookinIndia - Best Taxi Service in Chennai | Book Cabs Online"
          description="BookinIndia offers premium taxi service in Chennai. 24/7 cab booking, airport transfers, outstation trips, and local rides. Safe, reliable, and affordable cabs with professional drivers."
          keywords="taxi service chennai, cab booking chennai, airport taxi chennai, outstation cabs chennai, local taxi chennai"
          canonicalUrl="/"
        />
        
        <NavBar />
        <Routes>
          {/* Main Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/vehicle-selection" element={<VehicleSelection />} />
          <Route path="/contact-details" element={<ContactDetails />} />
          <Route path="/booking-success" element={<BookingSuccess />} />
          
          {/* Chennai Taxi SEO Routes - All point to same component for consistency */}
          <Route path="/chennai-taxi" element={<ChennaiTaxiMasterPage />} />
          <Route path="/chennai-airport-taxi" element={<ChennaiTaxiMasterPage />} />
          <Route path="/chennai-to-pondicherry-taxi" element={<ChennaiTaxiMasterPage />} />
          <Route path="/chennai-to-bangalore-taxi" element={<ChennaiTaxiMasterPage />} />
          <Route path="/local-taxi-chennai" element={<ChennaiTaxiMasterPage />} />
          
          {/* Auth and Admin */}
          <Route path="/sign-in" element={<AuthScreen />} />
          <Route path="/admin/dashboard" element={<AdminPanel />} />
          
          {/* Informational Pages */}
          <Route path="/offers" element={<OffersPageV3 />} />
          <Route path="/safety" element={<SafetyPage />} />
          <Route path="/support" element={<SupportPage />} />

          {/* Static SEO Pages */}
          <Route path="/cab-services" element={<StaticPageRoute pageKey="cabServices" />} />
          <Route path="/airport" element={<StaticPageRoute pageKey="airportTaxi" />} />
          <Route path="/outstation" element={<StaticPageRoute pageKey="outstationCabs" />} />
          <Route path="/hourly" element={<StaticPageRoute pageKey="hourlyRentals" />} />
          <Route path="/corporate" element={<StaticPageRoute pageKey="corporateTravel" />} />
          <Route path="/wedding" element={<StaticPageRoute pageKey="weddingFleet" />} />
          <Route path="/events" element={<StaticPageRoute pageKey="eventTransfers" />} />
          <Route path="/popular-routes" element={<StaticPageRoute pageKey="popularRoutes" />} />
          <Route path="/delhi-jaipur" element={<StaticPageRoute pageKey="delhiJaipur" />} />
          <Route path="/mumbai-pune" element={<StaticPageRoute pageKey="mumbaiPune" />} />
          <Route path="/bangalore-mysore" element={<StaticPageRoute pageKey="bangaloreMysore" />} />
          <Route path="/chennai-pondy" element={<StaticPageRoute pageKey="chennaiPondy" />} />
          <Route path="/kolkata-digha" element={<StaticPageRoute pageKey="kolkataDigha" />} />
          <Route path="/hyderabad-vizag" element={<StaticPageRoute pageKey="hyderabadVizag" />} />
          <Route path="/about" element={<StaticPageRoute pageKey="about" />} />
          <Route path="/careers" element={<StaticPageRoute pageKey="careers" />} />
          <Route path="/blog" element={<StaticPageRoute pageKey="blog" />} />
          <Route path="/press" element={<StaticPageRoute pageKey="press" />} />
          <Route path="/investors" element={<StaticPageRoute pageKey="investors" />} />
          <Route path="/sustainability" element={<StaticPageRoute pageKey="sustainability" />} />
          <Route path="/help" element={<StaticPageRoute pageKey="help" />} />
          <Route path="/cancellation" element={<StaticPageRoute pageKey="cancellation" />} />
          <Route path="/feedback" element={<StaticPageRoute pageKey="feedback" />} />
          <Route path="/report" element={<StaticPageRoute pageKey="report" />} />
          <Route path="/contact" element={<StaticPageRoute pageKey="contact" />} />
        </Routes>
        <Footer />
      </Router>
    </HelmetProvider>
  );
}

export default App;
